document.addEventListener('DOMContentLoaded', function() {
  const SWATCH_SELECTOR = '[data-hover-image]';
  
  function getVisibleImage() {
    const allItems = document.querySelectorAll('.product__media-item');
    for (let item of allItems) {
      if (item.offsetWidth > 0 && item.offsetHeight > 0) {
        return item.querySelector('.image__img') || item.querySelector('img'); 
      }
    }
    return document.querySelector('.product__media-item:not(.hidden) img'); // Fallback
  }

  document.addEventListener('mouseover', function(e) {
    const swatch = e.target.closest(SWATCH_SELECTOR);
    
    if (swatch) {
      const activeImg = getVisibleImage();
      const hoverImageUrl = swatch.dataset.hoverImage;

      if (activeImg && hoverImageUrl) {
        
        if (!activeImg.dataset.originalSrc) {
          activeImg.dataset.originalSrc = activeImg.src;
          activeImg.dataset.originalSrcset = activeImg.srcset || '';
        }

        activeImg.src = hoverImageUrl;
        activeImg.srcset = hoverImageUrl; 

        activeImg.removeAttribute('data-src');
        activeImg.removeAttribute('data-srcset');
      }
    }
  });

  document.addEventListener('mouseout', function(e) {
    const swatch = e.target.closest(SWATCH_SELECTOR);

    if (swatch) {
      const activeImg = getVisibleImage();

      if (activeImg && activeImg.dataset.originalSrc) {
        activeImg.src = activeImg.dataset.originalSrc;
        activeImg.srcset = activeImg.dataset.originalSrcset;

        delete activeImg.dataset.originalSrc;
        delete activeImg.dataset.originalSrcset;
      }
    }
  });

});

// FitMagik variant sync fix
// Ensures FitMagik uses the customer's selected color variant image
(function() {
  function syncFitMagikVariant() {
      var variantSelect = document.querySelector('select[name="id"]');
          if (!variantSelect) return;
              var variantId = variantSelect.value;
                  // FitMagik reads the product variant image from the page
                      // Update its internal product image reference on variant change
                          var productImgEl = document.querySelector('.fitmagik-product-image, [data-fitmagik-product-image]');
                              if (productImgEl) {
                                    // Get the currently displayed product image src
                                          var currentImg = document.querySelector('.product__media-item:not(.hidden) img, .product__photo img');
                                                if (currentImg && currentImg.src) {
                                                        productImgEl.src = currentImg.src;
                                                              }
                                                                  }
                                                                      // Dispatch custom event that FitMagik may listen to
                                                                          document.dispatchEvent(new CustomEvent('fitmagik:variant:changed', {
                                                                                detail: { variantId: variantId },
                                                                                      bubbles: true
                                                                                          }));
                                                                                            }

                                                                                              document.addEventListener('change', function(e) {
                                                                                                  if (e.target && (e.target.name === 'id' || e.target.name === 'options[Color]' || e.target.name === 'options[Size]')) {
                                                                                                        setTimeout(syncFitMagikVariant, 100);
                                                                                                            }
                                                                                                              });

                                                                                                                // Also watch for Shopify variant URL changes
                                                                                                                  var lastVariant = null;
                                                                                                                    setInterval(function() {
                                                                                                                        var variantSelect = document.querySelector('select[name="id"]');
                                                                                                                            if (variantSelect && variantSelect.value !== lastVariant) {
                                                                                                                                  lastVariant = variantSelect.value;
                                                                                                                                        syncFitMagikVariant();
                                                                                                                                            }
                                                                                                                                              }, 500);
                                                                                                                                              })();